import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'
import { isFrench } from '../config'

import ProductGrid from './ProductGrid'
import SelectedFilters from './SelectedFilters'
import useGroupProducts from '../category/useGroupProducts'

export default ({ sidebarActive, collectionGroups }) => {
    const { response: { products }, loading, pageType } = useAppState();
    const foundProducts = products && products.total > 0;
    const { groupedHits } = useGroupProducts(collectionGroups);

    useEffect(() => {
        if(foundProducts && window.Yotpo && window.yotpo) {
            const yotpoApi = new window.Yotpo.API(window.yotpo);
            yotpoApi.refreshWidgets();
        }
        if(window.nostojs) {
            setTimeout(() => {
                window.nostojs(function(api){ 
                    api.loadRecommendations() 
                })
            }, 300)
        }
    }, [ products ])

    return (
        <div class="w-full" style={loading ? 'opacity: 0.3;' : ''}>
            <SelectedFilters />
            <div class="ns-product-grid-wrapper flex flex-col px-5 laptop:px-10">
                {(collectionGroups?.length && groupedHits?.length) ? (
                    <>
                        {groupedHits.map((group, index) => (
                            group.products?.length > 0 ? (
                                <div 
                                    key={index} 
                                    id={`ns-sub-collection-${index + 1}`} 
                                    className="ns-sub-collection flex flex-col gap-3"
                                >
                                    <div class="">
                                        <h3 class="ns-sub-collection-heading">{(isFrench) ? group.title.fr : group.title.en}</h3>
                                        <div class="ns-sub-collection-desc">{(isFrench) ? group.description.fr : group.description.en}</div>
                                    </div>
                                    <ProductGrid 
                                        products={group.products}
                                        sidebarActive={sidebarActive}
                                    />
                                </div>
                            ) : ( null )
                        ))}
                    </>
                ) : (
                    <ProductGrid 
                        products={products.hits}
                        sidebarActive={sidebarActive}
                    />
                )}
            </div>
        </div>
    )
}
